import {_} from "vue-underscore";
import {EventBus} from "../../event-bus";
// Use this in your component which has a child PlayerjsPlayer
//
// >> async created() {
//      this.loadPlayerJs();
//      // your custom code
//      this.initPlayerJs();
//    },

export const PlayerjsMixin = {
  data() {
    return {
      playerJsInitialized: false
    }
  },
  computed: {
    playerOptions() {
      // return empty options
      // it should be implemented in Playerjs component
      return {}
    }
  },
  methods: {
    // Playerjs.js injection stuff
    isJsLoaded() {
      const loaded = _.filter(
         document.scripts,
         script => script.src === '/static/src/js/playerjs.js'
       )
      return loaded.length > 0
    },
    loadPlayerJs() {
       if (!this.isJsLoaded()) {
         const script = document.createElement("script");
         script.src = "/static/src/js/playerjs.js";
         document.head.appendChild(script);
       }
    },
    // Player stuff
    initPlayerJs(id = undefined) {
      setTimeout(function() {
        EventBus.$emit('init-player-js', {id})
      }, 1000);
    },
    handlePlayerJs(handlerId = undefined) {
      // Using in PlayerjsPlayer.vue component
      // to bind player initialization when have got 'init-player-js' event on EventBus
      EventBus.$on('init-player-js', ({id}) => {
        if (handlerId && id && handlerId !== id) return;
        this.initPlayer();
      });
      EventBus.$on('destroy-player-js', ({id}) => {
        if (handlerId && id && handlerId !== id) return;
        this.destroyPlayer();
      });
    },
    initPlayer() {
      if (!this.playerOptions) return;
      this.playerJsInitialized = true;
      setTimeout(() => {this.buildPlayer()}, 300 )
    },
    buildPlayer() {
      new Playerjs(this.playerOptions);
    },
    destroyPlayer() {
      const player = document.getElementById(this.playerId)
      if (player) player.remove()
    }
  }
}
